import { observable, action, computed, runInAction } from "mobx";
import * as mobx from 'mobx';

import * as content from '../communicator/content';

class StoreUi {
    active_nav = 0
    nav_mobile = false

    main_nav = [{
        id: 1,
        name: 'home',
        display_value: 'home',
        path: "/"
    },{
        id: 2,
        name: 'about',
        display_value: 'about',
        path: "/about",
    },{
        id: 3,
        name: 'brands',
        display_value: 'brands',
        path: "/brands",
    },
    // {
    //     id: 4,
    //     name: 'bridal',
    //     display_value: 'bridal',
    //     path: "/bridal"
    // },
    {
        id: 5,
        name: 'contact',
        display_value: 'contact',
        path: "/contact"
    }]

    sub_nav = [{
        id: 1,
        name: 'brands',
        display_value: 'brands',
        values: [{
            name: 'japantky',
            display_value: 'JapanTKY',
            path: '/japantky',
            url: 'https://www.japantky.com',
            lookbook: 'https://www.japantky.com/fashion/impression-fw2021/',
            active: 1
        },{
            name: 'lasalle',
            display_value: 'LaSalle',
            path: '/lasalle',
            url: 'https://www.lasalle-fashion.com/web/',
            lookbook: '',
            active: 1
        },{
            name: 'inti',
            display_value: 'Inti Knitwear',
            path: '/inti',
            url: 'https://www.intiknitwear.com',
            lookbook: 'https://www.intiknitwear.com/lookbook/',
            active: 1
        },{
            name: 'marivie',
            display_value: 'Marivie',
            path: '/marivie',
            url: 'https://www.marivie.com',
            lookbook: '',
            active: 1
        }]
    },{
        id: 2,
        name: 'bridal',
        display_value: 'bridal',
        values: [{
            name: 'infinit',
            display_value: 'Infinit Barcelona',
            path: '/infinit',
            url: 'https://infinitbarcelona.com/gb/',
            lookbook: 'https://www.instagram.com/infinitdressbcn/'
        }]
    }]

    constructor() {

    }

    startLoader() {
        this.app_interface.loader = true;
    }

    stopLoader() {
        this.app_interface.loader = false;
    }

    async getBrandData(brand) {
        let data;
        try {
            const returnData = await content.getBrandData(brand);

            runInAction(() => {
                data = returnData;
                return data;
            })
        } catch (error) {
            runInAction(() => {
                this.state = "error"
            })
        } finally {

        }
        return data;
    }

    async getDataCarousel(section) {
        let data;
        try {
            const returnData = await content.getDataCarousel(section);
            runInAction(() => {
                data = returnData;
                return data;
            })
        } catch (error) {
            runInAction(() => {
                this.state = "error"
            })
        } finally {

        }
        return data;
    }

    setNavMobile(state) {
        if (state != undefined) {
            this.nav_mobile = state;
        } else {
            this.nav_mobile = !this.nav_mobile;
        }
    }
    
}

export default StoreUi;